
import { Component, Prop, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import { SnackbarNotificationType } from 'vuexstore/modules/global_snackbar'

@Component({
  components: { OzIcon, OzTextButton },
})
export default class extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme
  SnackbarNotificationType = SnackbarNotificationType

  /**
   * Type of snakcbar notification
   */
  @Prop({ required: true, default: SnackbarNotificationType.success }) notificationType!: SnackbarNotificationType

  /**
   * Displayed message of the snackbar
   */
  @Prop({ required: true }) message!: string

  /**
   * Icon to display on the snackbar
   */
  @Prop({ required: false }) iconName!: string

  /**
   * Unique id associated with the snackbar
   */
  @Prop({ required: true }) uid!: string

  /**
   * Text for clickable action
   */
  @Prop({ required: false }) actionText!: string

  /**
   * Whether dark mode is active or not
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  actionTextClick(event) {
    /**
     * Click event
     * @property {MouseEvent} event click event
     */
    this.$emit('action-text-click', event)
  }
}
